export const apiRoot = 'https://vision-api.meetglimpse.com'
